import { Injectable } from '@angular/core';

@Injectable()
export class DistanceToDeadlineService {

    /**
     * Return an int representing number of days to deadline since now.
     *
     * @return int
     **/
    public calculate(timeCost: string) {
        const parts = timeCost.split('.');
        return parseInt(parts[0], 0);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/services/distance-to-deadline.service.ts